import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Style/Login.css";
import backgroundImage from "../assets/Login_image/live.mp4";

const API_BASE_URL = "https://api.yellowmatrix.co.in";

export default function Login() {
  const [Username, setUsername] = useState("");
  const [Password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResetMessage, setShowResetMessage] = useState(false);
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Username,
          Password,
          captchaInput,
        }),
      });
      const data = await response.json();

      if (response.ok) {
        localStorage.setItem("token", data.access_token);

        localStorage.setItem("userRole", data.user.Role);

        localStorage.setItem(
          "permission",
          JSON.stringify(data.user.Permissions || []),
        );

        navigate("/Dashboard");
      } else {
        setErrorMessage(data.message || "Invalid username or password");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("An error occurred. Please try again");
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetClick = (e) => {
    e.preventDefault();
    setShowResetMessage(true);
  };

  const closeResetMessage = () => {
    setShowResetMessage(false);
  };

  useEffect(() => {
    fetchCaptcha();
  }, []);

  const fetchCaptcha = () => {
    setCaptchaImage(`${API_BASE_URL}/captcha?${Date.now()}`);
  };

  return (
    <div className="container-login">
      <video className="background-video" autoPlay loop muted>
        <source src={backgroundImage} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="form-box">
        {isLoading && (
          <div className="loading-overlay">
            <div className="spinner-login"></div>
          </div>
        )}

        <h1 className="title">Sign In</h1>
        <div className="underline"></div>
        <form onSubmit={handleSubmit}>
          <div className="input-g">
            <div className="input-field-sign">
              <i className="fa-solid fa-user"></i>
              <input
                type="text"
                placeholder="Username"
                required
                value={Username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div
              className="input-field-sign"
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
              }}
            >
              <i className="fa-solid fa-key"></i>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
                value={Password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ flex: 1 }}
              />
              <i
                className={`fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  cursor: "pointer",
                  paddingRight: "15px",
                  color: "#999",
                  position: "absolute",
                  right: "5px",
                }}
                title={showPassword ? "Hide Password" : "Show Password"}
              ></i>
            </div>

            <div className="input-field-sign">
              <i className="fa-solid fa-robot"></i>
              <input
                type="text"
                placeholder="Enter Captcha"
                value={captchaInput}
                onChange={(e) => setCaptchaInput(e.target.value)}
                required
              />
            </div>

            <div className="captcha-box">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <img
                  src={captchaImage}
                  alt="captcha"
                  onClick={fetchCaptcha}
                  style={{
                    cursor: "pointer",
                    marginBottom: "10px",
                  }}
                />
                <i
                  className="fa-solid fa-rotate"
                  onClick={fetchCaptcha}
                  style={{
                    cursor: "pointer",
                    color: "black",
                    fontSize: "20px",
                  }}
                  title="Refresh Captcha"
                ></i>
              </div>
            </div>

            <p>
              <span className="text">Lost Password?</span>
              <a href="/" onClick={handleResetClick}>
                {" "}
                Click Here!
              </a>
            </p>
          </div>
          {errorMessage && (
            <p className="error-message-login">
              {errorMessage.includes("device.ops@yellowmatrix.in") ? (
                <>
                  {errorMessage.split("device.ops@yellowmatrix.in")[0]}
                  <a
                    href="mailto:device.ops@yellowmatrix.in"
                    style={{ color: "#00c369", textDecoration: "none" }}
                  >
                    device.ops@yellowmatrix.in
                  </a>
                  {errorMessage.split("device.ops@yellowmatrix.in")[1]}
                </>
              ) : (
                errorMessage
              )}
            </p>
          )}
          <div className="btn-field">
            <button type="submit" className="signinbtn">
              Sign In
            </button>
          </div>
        </form>
      </div>

      {showResetMessage && (
        <>
          <div className="blur-background"></div>
          <div className="reset-message">
            <div className="icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Password Assistance</h3>
            <p>
              Please contact your system administrator to reset your password.
            </p>
            <button onClick={closeResetMessage}>Got It!</button>
          </div>
        </>
      )}
    </div>
  );
}
